import { Variant } from '@mui/material/styles/createTypography';
import { TypographyComponent } from '../typography/Typography';
import { BaseTextField } from './BaseTextField';
import { SxProps } from '@mui/material';

interface Props extends React.ComponentProps<typeof BaseTextField> {
  readOnly?: boolean; // New prop to make the field read-only
  typoVariant?: Variant;
  typoSx?: SxProps;
}

export function TextFieldReadOnly({ readOnly = false, typoVariant, typoSx, ...otherProps }: Props) {
  return readOnly ? (
    <TypographyComponent variant={typoVariant} sx={typoSx}>
      {otherProps.value as React.ReactNode}
    </TypographyComponent>
  ) : (
    <BaseTextField
      {...otherProps}
      InputProps={{
        ...otherProps.InputProps, // Spread existing InputProps
      }}
    />
  );
}
